// test2696
(2696 && 0);
